/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import { EXP_COMMERCIAL_ROOT_DOMAIN, getSubDomainUrl } from 'constants/domains';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';
import { ACCESSIBILITY_PATH } from 'constants/urls';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXPLORE_EXP_LABEL,
            defaultValue: 'Explore eXp',
          },
          link: '/explore-exp',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FIND_AGENT_LABEL,
            defaultValue: 'Find an Agent',
          },
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_JOIN_EXP_LABEL,
            defaultValue: 'Join eXp',
          },
          link: 'https://join.exprealty.com',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_INVESTOR_RELATIONS_LABEL,
            defaultValue: 'Investor Relations',
          },
          link: 'https://expworldholdings.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMPANY_CAREERS_LABEL,
            defaultValue: 'Company Careers',
          },
          link: 'https://expworldholdings.com/careers/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_HOME_GUIDES_LABEL,
            defaultValue: 'Home Guides',
          },
          link: 'https://exprealty.com/guides/',
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXP_LIFE_LABEL,
            defaultValue: 'eXp Life',
          },
          link: 'https://life.exprealty.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ZOOCASA_LABEL,
            defaultValue: 'Zoocasa',
          },
          link: 'https://zoocasa.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_SUCCESS_LABEL,
            defaultValue: 'SUCCESS®',
          },
          link: 'https://www.success.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_SUCCESS_LENDING_LABEL,
            defaultValue: 'SUCCESS® Lending',
          },
          link: 'https://www.successlending.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_REVENOS_LABEL,
            defaultValue: 'eXp Revenos',
          },
          link: 'https://revenos.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMMERCIAL_LABEL,
            defaultValue: 'eXp Commercial',
          },
          link: getSubDomainUrl(EXP_COMMERCIAL_ROOT_DOMAIN, 'www'),
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LUXURY_LABEL,
            defaultValue: 'eXp Luxury',
          },
          link: 'https://expluxury.com/?tl=en',
          target: 'blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ACCESSIBILITY_LABEL,
            defaultValue: 'Accessibility',
          },
          link: ACCESSIBILITY_PATH,
          isAnchor: true,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_TERMS_AND_CONDITIONS_LABEL,
            defaultValue: 'Terms and Conditions',
          },
          link: 'https://expworldholdings.com/terms-of-service/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACY_RIGHTS_REQUEST_LABEL,
            defaultValue: 'Privacy Rights Request',
          },
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACY_POLICY_LABEL,
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_COOKIE_POLICY_LABEL,
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_BRAND_GUIDELINES_LABEL,
            defaultValue: 'Brand Guidelines',
          },
          link: 'https://join.exprealty.com/brand/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_HELP_LABEL,
            defaultValue: 'Help',
          },
          link: 'https://searchhelp.exprealty.com/hc/en-us/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_SITEMAP_LABEL,
            defaultValue: 'Sitemap',
          },
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COPYRIGHT_LABEL,
              defaultValue: '© 2024 eXp Realty. eXp World Holdings, Inc. All Rights Reserved.',
            },
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: ' ',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_DMCA_LABEL,
              defaultValue: 'DMCA Notice',
            },
            link: '/dmca',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PROTECTED,
              defaultValue: 'This site is protected by reCAPTCHA and the Google ',
            },
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_PRIVACY_POLICY,
              defaultValue: 'Privacy Policy',
            },
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_AND,
              defaultValue: ' and ',
            },
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_TERMS_OF_SERVICE,
              defaultValue: 'Terms of Service',
            },
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_RECAPTCHA_APPLY,
              defaultValue: ' apply',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FAIR_HOUSING_LABEL,
              defaultValue: 'Fair Housing and Reasonable Accommodations',
            },
            link: '/fair-housing-and-reasonable-accommodations',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_MLS_COMPLIANCE_LABEL,
              defaultValue: 'MLS Compliance Statements',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_TEXAS,
              defaultValue: 'Karen Richards - Designated Managing Broker, Broker Operations - TX',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXAS_BROKERAGE_SERVICES_LABEL,
              defaultValue: 'Texas Real Estate Commission information about brokerage services',
            },
            link: 'https://dtzulyujzhqiu.cloudfront.net/expcorporate377/compliance/tx/entity/377_30621_iabs.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_TEXAS_CONSUMER_PROTECTION_LABEL,
              defaultValue: 'Texas Real Estate Commission Consumer Protection Notice',
            },
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_LABEL,
              defaultValue: 'eXp Realty® is committed to adhering to the guidelines of The New York State Fair Housing Regulations.',
            },
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_NOTICE,
              defaultValue: 'The Fair Housing Notice',
            },
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_STANDARDIZED_OPERATING_PROCEDURE_LABEL,
              defaultValue: '*Standardized Operating Procedure for Purchasers of Real Estate Pursuant to Real Property Law 442-H.',
            },
          },
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_DISCLOSURES_FAIR_HOUSING_LEARN_MORE,
              defaultValue: 'Learn More',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: '',
              defaultValue: ' ',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_CALIFORNIA,
              defaultValue: 'eXp Realty of California, Inc. | CA DRE# 01878277 | Deborah Penny - Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_SOUTHERN_CALIFORNIA,
              defaultValue: 'eXp Realty of Southern California, Inc. | CA DRE#01325837 | Jason Crawford – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_GREATER_LOS_ANGELES,
              defaultValue: 'eXp Realty of Greater Los Angeles, Inc. | CA DRE# 01240990 | Mike Mendibles - Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_BROKERS_NORTHERN_CALIFORNIA,
              defaultValue: 'eXp Realty of Northern California, Inc. | CA DRE# 01951343 | Ryan Rosas - Designated Broker',
            },
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.com',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-us.jpg',
        alt: {
          key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_IMAGE_ALT,
          defaultValue: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
        },
      },
    },
    showAccessibilityLink: true,
  };
}